const SCROLLSTOP_TIMEOUT_MS = 150;

const { debounce } = require('lodash'),
    scrollSize = require('scrollbar-size');

class ProductCarouselController {
    constructor($scope, $element, $timeout) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;

        this.$scope.$on('window:widthResize', () => this.initLayout());
    }

    $postLink() {
        this.$timeout(() => this.getCarouselElements(), 0, false);
    }

    getCarouselElements() {
        this.$scrollWrapper = this.$element.find('._productCarousel-scrollWrapper');
        this.$scrollContainer = this.$element.find('._productCarousel-scrollContainer');
        this.$items = this.$element.find('._productCarousel-item');
        this.initLayout();
    }

    initLayout() {
        this.$scrollWrapper.height(this.$scrollContainer.outerHeight() - scrollSize());

        this.carouselScrollWidth = this.$scrollContainer.get(0).scrollWidth;
        this.carouselOffsetWidth = this.$scrollContainer.width();
        this.itemWidth = this.$items.width();

        this.displayArrowExecute();

        this.displayArrow = debounce(this.displayArrowExecute, SCROLLSTOP_TIMEOUT_MS);

        this.$scrollContainer.off('scroll').on('scroll', () => {
            this.displayArrow();
        });
    }

    get carouselScrollLeft() {
        return this.$scrollContainer.scrollLeft();
    }/**
     * Decides whether or not the carousel should display arrows.
     *
     * @param {Number} [carouselOffsetWidth=this.carouselOffsetWidth]
     * @param {Number} [carouselScrollWidth=this.carouselScrollWidth]
     *
     * @memberOf RrCarouselController
     */
    displayArrowExecute(
        carouselOffsetWidth = this.carouselOffsetWidth,
        carouselScrollWidth = this.carouselScrollWidth,
    ) {
        this.isScrollable = carouselScrollWidth >= carouselOffsetWidth;

        if (this.isScrollable) {
            this.updateArrow();
        }
    }

    /**
     * Toggles enabled state of left and right arrows based on current scroll position.
     *
     * @param {Number} [scrollLeft=this.carouselScrollLeft]
     * @param {Number} [carouselScrollWidth=this.carouselScrollWidth]
     * @param {Number} [carouselOffsetWidth=this.carouselOffsetWidth]
     *
     * @memberOf RrCarouselController
     */
    updateArrow(
        scrollLeft = this.carouselScrollLeft,
        carouselScrollWidth = this.carouselScrollWidth,
        carouselOffsetWidth = this.carouselOffsetWidth,
    ) {
        this.$timeout(() => {
            this.isLeftArrowDisabled = scrollLeft <= 0;
            this.isRightArrowDisabled = scrollLeft >= (carouselScrollWidth - carouselOffsetWidth);
        });
    }

    /**
     * Calculates the new leftScroll value after scrolling left or right.
     * Scrolls by one viewport width.
     *
     * @param {Boolean} right
     * @param {Number} [itemWidth=this.itemWidth]
     * @param {Number} [scrollLeft=this.carouselScrollLeft]
     * @param {Number} [carouselWidth=this.carouselOffsetWidth]
     * @returns {Number}
     *
     * @memberOf RrCarouselController
     */
    calculateNewScrollPosition(
        right,
        itemWidth = this.itemWidth,
        scrollLeft = this.carouselScrollLeft,
        carouselWidth = this.carouselOffsetWidth,
    ) {
        const numItemsViewable = carouselWidth / itemWidth;

        let targetScroll = 0;

        if (right) {
            // move the carousel one viewport to the right
            targetScroll = scrollLeft + (numItemsViewable * itemWidth);
            // round to the nearest visible card.
            targetScroll = Math.floor(targetScroll / itemWidth) * itemWidth; // anchor to left corner of card
        } else {
            // move the carousel one viewport to the left
            targetScroll = scrollLeft - (numItemsViewable * itemWidth);
            // round to the nearest fully visible card
            targetScroll = Math.ceil(targetScroll / itemWidth) * itemWidth;
        }

        return targetScroll;
    }

    scrollLeft() {
        this.animateScrolling(this.calculateNewScrollPosition(false));
    }

    scrollRight() {
        this.animateScrolling(this.calculateNewScrollPosition(true));
    }

    animateScrolling(targetScroll) {
        this.$scrollContainer.animate({
            scrollLeft: targetScroll,
        }, 200);
        this.$scrollWrapper.hide().show(0);
    }
}

ProductCarouselController.$inject = [];

const productCarouselComponentDefinition = {
    bindings: {
        products: '=',
    },
    controller: ['$scope', '$element', '$timeout', ProductCarouselController],
    template: require('./product-carousel.component.html').trim(),
};

module.exports = {
    ProductCarouselController,
    productCarouselComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/productcarousel/product-carousel.component.js